export const RoomSizes: RoomSize[] = [
  {
    title: 'Mini',
    image: 'mini',
    numberParticipants: 10,
    size: 2000,
  },
  {
    title: 'Small',
    image: 'small',
    numberParticipants: 25,
    size: 4000,
  },
  {
    title: 'Medium',
    image: 'medium',
    numberParticipants: 75,
    size: 8000,
  },
  {
    title: 'Large',
    image: 'large',
    numberParticipants: 125,
    size: 12000,
  },
  {
    title: 'Extra large',
    image: 'extra-large',
    numberParticipants: 200,
    size: 16000,
  },
  {
    title: 'Jumbo',
    image: 'jumbo',
    numberParticipants: 300,
    size: 20000,
  },
];

export interface RoomSize {
  title: string;
  image: string;
  numberParticipants: number;
  size: number;
}
